<template>
    <div class="flex flex-col overflow-hidden">
        <div class="h-10 py-1">
            <hts-form-toggle
                v-model="expanded"
                size="v-mini"
                color="primary"
                class="inline-block"
                label="Tác vụ: Expand/Collapse"
                @click="toggleExpandCollapse()" />
        </div>
        <hts-travel-details
            ref="travelRoute"
            :travel-details="travelDetails"
            direction="horizontal"
            class="flex-1 overflow-auto"
            @clickStep="clickStep" />
    </div>
</template>

<script setup lang="ts">
import routeMap from '@/pages/trucker-[id]/route/ignore/route-map'

const { setMarkers, setRoutes, setRoutingPositions } = routeMap()

const emits = defineEmits(['modify', 'update-route', 'open-timing', 'open-planning'])
const travelRoute = ref<any>(null)
const props = defineProps({
  travelDetails: {
    type: Array<any>,
    required: true
  }
})

const { travelDetails } = toRefs(props)
const expanded = ref(false)
const showJourney = ref(false)

const clickStep = (value: any) => {}

const toggleExpandCollapse = () => {
  if (!travelRoute.value) {
    return
  }
  travelRoute.value.toggleExpandCollapse()
}

const openPlanning = (e: any) => {
  emits('open-planning', e)
}
const openTiming = (e: any) => {
  emits('open-timing', e)
}

defineExpose({})
</script>
